'use strict';

function extractResponseParts(text, url) {
  return {
    "bodyDocument": extractBodyAsDom(text),
    "title": extractTitle(text),
    "analytics": extractAnalytics(text),
    "jsonPageData" : extractJsonPageData(text),
    "url": url
  }
}

function extractBody(html) {
  var bodyContentMatches = html.match(/<body\b[^>]*>([\s\S.]*)?<\/body>/)

  if (bodyContentMatches && bodyContentMatches.length == 2) {
    return bodyContentMatches[1];
  } else {
    return "";
  }
}

function extractHead(html) {
  var headContentMatches = html.match(/<head\b[^>]*>([\s\S.]*)?<\/head>/)

  if (headContentMatches && headContentMatches.length == 2) {
    return headContentMatches[1];
  } else {
    return "";
  }
}

function extractHeadAsDom(headText) {
  let newDoc = document.implementation.createHTMLDocument("new doc");
  let headElements = newDoc.getElementsByTagName('head');

  if (headElements.length) {
    headElements[0].innerHTML = headText
  }

  return newDoc.getElementsByTagName('head')[0];
}

function extractAnalytics(html) {
  let jsonDeclaration = ""
  let headContent = extractHeadAsDom(extractHead(html))
  let scriptTags = headContent.getElementsByTagName('script');

  for (var i=0; i<scriptTags.length; i++) {
    if(scriptTags[i].getAttribute("purpose") == "analytics") {
      jsonDeclaration += scriptTags[i].innerHTML
    }
  }

  var jsonValue = /=(.*?});/.exec(jsonDeclaration);
  return (jsonValue == null) ? null : JSON.parse(jsonValue[1]);
}

function extractTitle(html) {
  let headContent = extractHeadAsDom(extractHead(html));

  let titleElements = headContent.getElementsByTagName('title');
  return (titleElements.length) ? titleElements[0].innerHTML : "";
}

function extractJsonPageData(html) {
  let headContent = extractHeadAsDom(extractHead(html))
  let jsonPageData = '';
  let scriptTags = headContent.getElementsByTagName('script');

  for (var i=0; i<scriptTags.length; i++) {
    if(scriptTags[i].getAttribute("id") == "jsonPageData") {
      jsonPageData += scriptTags[i].innerHTML
    }
  }
  return jsonPageData;
}

function extractBodyAsDom(html) {
  return convertToDom(extractBody(html));
}

function convertToDom(fragment) {
  let container = document.createElement('section');
  container.innerHTML = fragment;
  purgeScriptElements(container);
  return container;
}

function purgeScriptElements(domContent) {
  var scriptTags = domContent.getElementsByTagName('script');

  for (var i=0; i<scriptTags.length; i++) {
    var item = scriptTags[i];
    item.parentNode.removeChild(item);
  }
}

let ServerSupport = {
  extractBody,
  convertToDom,
  extractBodyAsDom,
  extractTitle,
  extractResponseParts,
  extractAnalytics,
  extractJsonPageData
};

export default ServerSupport;
